import { Components, Theme } from "@mui/material/styles";

import { badgeColors } from "./palette";

type BadgeColor =
  | "brand"
  | "neutral"
  | "accent1"
  | "accent2"
  | "accent3"
  | "success"
  | "warning"
  | "error"
  | "reference"
  | "info";

type BadgeStyle = "bold" | "muted";
type BadgeVariant = `${BadgeColor}-${BadgeStyle}`;

const fontFamilyBody = "'Work Sans', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif";

const badgeBaseStyles = {
  borderRadius: "4px",
  height: "auto",
  border: "none",
  "&.MuiChip-sizeMedium .MuiChip-label": {
    padding: "0 8px",
    fontFamily: fontFamilyBody,
    fontSize: "1rem",
    lineHeight: "1.5em",
    letterSpacing: "-0.5px",
    fontWeight: 500,
  },
  "&.MuiChip-sizeSmall .MuiChip-label": {
    padding: "0 8px",
    fontFamily: fontFamilyBody,
    fontSize: "14px",
    lineHeight: "1rem",
    letterSpacing: "0",
    fontWeight: 500,
  },
};

const badgeVariants = (color: BadgeColor) => [
  {
    props: { variant: `${color}-bold` as BadgeVariant },
    style: {
      ...badgeBaseStyles,
      backgroundColor: badgeColors[`${color}Bold`],
    },
  },
  {
    props: { variant: `${color}-muted` as BadgeVariant },
    style: {
      ...badgeBaseStyles,
      backgroundColor: badgeColors[`${color}Muted`],
    },
  },
];

export const MuiChip: Components<Theme>["MuiChip"] = {
  variants: [
    ...badgeVariants("brand"),
    ...badgeVariants("neutral"),
    ...badgeVariants("accent1"),
    ...badgeVariants("accent2"),
    ...badgeVariants("accent3"),
    ...badgeVariants("success"),
    ...badgeVariants("warning"),
    ...badgeVariants("error"),
    ...badgeVariants("reference"),
    ...badgeVariants("info"),
  ],
};
